import type { VideoJsPlayer } from 'video.js';

import videojs from 'video.js';

import { getVideoJSSources } from './get-videojs-sources';
import { getHiveSources } from '../p2p/hive';
import { PlayerSources } from '../player.config';
import { Plugins } from '../player.interface';

export async function getSources(
  player: VideoJsPlayer,
  sources: PlayerSources,
  plugins: Plugins,
  abortSignal: AbortSignal,
  preferredQuality?: string
): Promise<videojs.Tech.SourceObject[]> {
  const videoJsSources = getVideoJSSources(sources, preferredQuality);

  const hiveSources = plugins.hive && (await getHiveSources(player, plugins.hive, abortSignal));

  if (hiveSources) {
    return hiveSources;
  }

  return videoJsSources;
}
